import gql from "graphql-tag"

export const ALL_EXTERNAL_PRICE_PROVIDERS = gql`
  query getExternalPriceConfigs {
    getExternalPriceConfigs {
      id
    }
  }
`
